module.exports = __webpack_public_path__ + "img/icon-1.ef2a87f3.png";